import { render, staticRenderFns } from "./location.vue?vue&type=template&id=54198a84"
import script from "./location.vue?vue&type=script&lang=ts"
export * from "./location.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports